import { all, put, select, takeEvery } from 'redux-saga/effects';
import { ActionType } from 'typesafe-actions';

import {
  accountKnoOrganizationFunctionsGet,
  accountOrganizationsWithDistrictGet,
} from 'CorePackage/AccountModule/actions/accountActions';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import { DictionariesActionsEnum } from 'CorePackage/DictionariesModule/enums/DictionariesActionsEnum';
import {
  catalogErknmKnmConditionsGet,
  catalogErknmKnmRejectReasonTypesGet,
  catalogGet,
  catalogKnmReasonTypesGet,
  catalogKnmRejectReasonTypesGet,
  catalogKnmSupervisionTypesByKnmTypeAndSubjectTypeGet,
  catalogKnmTypes248Get,
  catalogPmConditionsGet,
} from 'CorePackage/CatalogsModule/actions/catalogsActions';
import { CommonCatalogsNamesEnum } from 'CorePackage/CatalogsModule/enums/CommonCatalogsNamesEnum';
import {
  dictionariesAcceptedDocumentsItemGet,
  dictionariesChecklistsItemGet,
  dictionariesConditionTypesItemGet,
  dictionariesDangerClassesItemGet,
  dictionariesErvkCheckListGet,
  dictionariesEventHasUnplannedActivityGet,
  dictionariesEventTypesItemGet,
  dictionariesEventUuidGet,
  dictionariesKnmKindsItemGet,
  dictionariesKnmTypesItemGet,
  dictionariesKnoOrganizationsItemGet,
  dictionariesKnoSupervisionGet,
  dictionariesParticipantPositionsItemGet,
  dictionariesPermitDocsItemGet,
  dictionariesPmProfEventTypesItemGet,
  dictionariesPositionsItemGet,
  dictionariesProfKindsItemGet,
  dictionariesRequirementsItemGet,
  dictionariesRiskCategoriesItemGet,
  dictionariesRiskIndicatorsItemGet,
  dictionariesSubjectKindsItemGet,
  dictionariesSubjectSubKindsItemGet,
  dictionariesSubjectTypesItemGet,
  dictionariesSupervisionTypesItemGet,
  dictionariesTargetEntityFounderItemGet,
  dictionariesTargetEntityItemGet,
} from 'CorePackage/DictionariesModule/actions/dictionariesActions';
import { KnmTypeCodesEnum } from 'APIPackage/CatalogsModule/enums/KnmTypeCodesEnum';
import { registryExportOkvedGet } from 'CorePackage/RegistryModule/actions/registryActions';
import { getCoreIsErknm } from 'CorePackage/MainModule/selectors/coreSelectors';

import {
  getControlKindUuid,
  getKnmDataErknmObjects,
  getKnmDataPlanId,
  getKnmPmIsUnableToRefuseFormValue,
  getKnmErknmKnmKindDictVersionIdFormValue,
  getKnmErknmKnoOrganizationDictVersionIdFormValue,
  getKnmErknmReasonsFormValue,
  getKnmErknmSupervisionTypeDictVersionIdFormValue,
  getKnmEventUuid,
  getKnmFormRef,
  getKnmIsTypeErknmPlanned,
  getKnmKnoOrganizationIdFormValue,
  getKnmKnoSupervisionUuid,
  getKnmPmReasonsFormValue,
  getKnmSubjectTypeIdFormValue,
  getKnmSystemType,
  getKnmTypeFormValue,
  getKnmTypeIdFormValue,
} from '../selectors/knmSelectors';
import { KnmSystemTypesEnum } from '../enums/KnmSystemTypesEnum';
import { KnmActionsEnum } from '../enums/KnmActionsEnum';
import { knmSetLegalEntityData } from '../actions/knmActions';
import { FEDERAL_LOW_248_GUID } from '../constants/erknmFederalLawUuid';

export function* watchKnmDictionariesSaga() {
  yield takeEvery([KnmActionsEnum.KNM_CATALOGS_INIT, KnmActionsEnum.KNM_SET_SYSTEM_TYPE], initCommonCatalogsSaga);
  yield takeEvery(KnmActionsEnum.KNM_SET_SYSTEM_TYPE, initAccountOrganizationsWithDistrictSaga);
  yield takeEvery(KnmActionsEnum.KNM_SET_TYPE_FORM_VALUE, initCatalogKnmReasonTypesSaga);
  yield takeEvery(KnmActionsEnum.KNM_SET_ERKNM_KNM_KIND_VERSION_ID_FORM_VALUE, initCatalogKnmReasonTypesSaga);
  yield takeEvery(KnmActionsEnum.KNM_SET_TYPE_FORM_VALUE, initCatalogKnmRejectReasonTypesSaga);
  yield takeEvery(KnmActionsEnum.KNM_SET_TYPE_FORM_VALUE, initCatalogErknmKnmRejectReasonTypesSaga);
  yield takeEvery(
    [
      KnmActionsEnum.KNM_SET_SYSTEM_TYPE,
      KnmActionsEnum.KNM_SET_KNO_ORGANIZATION_FORM_VALUE,
      KnmActionsEnum.KNM_KNO_ORGANIZATION_FUNCTIONS_GET,
    ],
    initAccountKnoOrganizationFunctionsSaga,
  );

  yield takeEvery(
    [
      KnmActionsEnum.KNM_SET_TYPE_FORM_VALUE,
      KnmActionsEnum.KNM_SET_SYSTEM_TYPE,
      KnmActionsEnum.KNM_SET_ERKNM_KNO_ORGANIZATION_FORM_VALUE,
      KnmActionsEnum.KNM_SET_ERKNM_SUPERVISION_TYPE_FORM_VALUE,
      KnmActionsEnum.KNM_SET_ERKNM_KNM_KIND_VERSION_ID_FORM_VALUE,
    ],
    initCatalogErknmKnmConditionsSaga,
  );
  yield takeEvery(
    [
      KnmActionsEnum.KNM_SET_TYPE_FORM_VALUE,
      KnmActionsEnum.KNM_SET_SYSTEM_TYPE,
      KnmActionsEnum.KNM_SET_ERKNM_SUPERVISION_TYPE_FORM_VALUE,
      KnmActionsEnum.KNM_SET_ERKNM_KNM_KIND_VERSION_ID_FORM_VALUE,
    ],
    initCatalogPmReasonTypesSaga,
  );
  yield takeEvery(
    [KnmActionsEnum.KNM_SET_SUBJECT_TYPE_FORM_VALUE, KnmActionsEnum.KNM_SET_TYPE_FORM_VALUE],
    initCatalogKnmSupervisionTypesByKnmTypeAndSubjectTypeSaga,
  );
  yield takeEvery(KnmActionsEnum.KNM_SET_ERKNM_KNO_ORGANIZATION_FORM_VALUE, initDictionaryKnmSupervisionTypesSaga);
  yield takeEvery(
    [
      KnmActionsEnum.KNM_SET_ERKNM_KNO_ORGANIZATION_FORM_VALUE,
      KnmActionsEnum.KNM_SET_ERKNM_SUPERVISION_TYPE_FORM_VALUE,
    ],
    initDictionaryChecklistsSaga,
  );
  yield takeEvery(
    [
      KnmActionsEnum.KNM_SET_ERKNM_KNO_ORGANIZATION_FORM_VALUE,
      KnmActionsEnum.KNM_SET_ERKNM_SUPERVISION_TYPE_FORM_VALUE,
    ],
    initDictionariesKnmTypesByKnoAndSupervisionSaga,
  );
  yield takeEvery(
    [
      KnmActionsEnum.KNM_SET_ERKNM_KNM_KIND_VERSION_ID_FORM_VALUE,
      KnmActionsEnum.KNM_SET_ERKNM_SUPERVISION_TYPE_FORM_VALUE,
    ],
    initErvkChecklistsSaga,
  );
  yield takeEvery(
    [
      KnmActionsEnum.KNM_SET_RAW_DATA,
      KnmActionsEnum.KNM_SET_ERKNM_KNO_ORGANIZATION_FORM_VALUE,
      KnmActionsEnum.KNM_SET_ERKNM_SUPERVISION_TYPE_FORM_VALUE,
    ],
    initDictionaryRequirementsSaga,
  );
  yield takeEvery(KnmActionsEnum.KNM_SET_LEGAL_ENTITY_DATA, initRegistryExportOkvedSaga);
  yield takeEvery(
    [
      KnmActionsEnum.KNM_SET_SYSTEM_TYPE,
      KnmActionsEnum.KNM_SET_ERKNM_KNO_ORGANIZATION_FORM_VALUE,
      KnmActionsEnum.KNM_SET_ERKNM_SUPERVISION_TYPE_FORM_VALUE,
    ],
    initDictionariesKnoSupervisionUuidSaga,
  );
  yield takeEvery(
    [
      KnmActionsEnum.KNM_SET_SYSTEM_TYPE,
      KnmActionsEnum.KNM_SET_ERKNM_KNO_ORGANIZATION_FORM_VALUE,
      KnmActionsEnum.KNM_SET_ERKNM_SUPERVISION_TYPE_FORM_VALUE,
      KnmActionsEnum.KNM_SET_ERKNM_REASONS_FORM_VALUE,
    ],
    initDictionaryKnmKindsSaga,
  );
  yield takeEvery(
    [
      KnmActionsEnum.KNM_SET_SYSTEM_TYPE,
      KnmActionsEnum.KNM_SET_ERKNM_KNO_ORGANIZATION_FORM_VALUE,
      KnmActionsEnum.KNM_SET_ERKNM_SUPERVISION_TYPE_FORM_VALUE,
      KnmActionsEnum.KNM_SET_ERKNM_REASONS_FORM_VALUE,
    ],
    initDictionaryProfKindsSaga,
  );
  yield takeEvery(
    [
      KnmActionsEnum.KNM_SET_SYSTEM_TYPE,
      KnmActionsEnum.KNM_SET_ERKNM_KNO_ORGANIZATION_FORM_VALUE,
      KnmActionsEnum.KNM_SET_ERKNM_SUPERVISION_TYPE_FORM_VALUE,
    ],
    initDictionariesAcceptedDocuments,
  );
  yield takeEvery(
    [
      KnmActionsEnum.KNM_SET_SYSTEM_TYPE,
      KnmActionsEnum.KNM_SET_ERKNM_KNO_ORGANIZATION_FORM_VALUE,
      KnmActionsEnum.KNM_SET_ERKNM_SUPERVISION_TYPE_FORM_VALUE,
      KnmActionsEnum.KNM_SET_ERKNM_REASONS_FORM_VALUE,
      KnmActionsEnum.KNM_SET_ERKNM_SUPERVISION_TYPE_FORM_VALUE,
    ],
    initDictionariesTargetEntity,
  );
  yield takeEvery(
    [
      KnmActionsEnum.KNM_SET_SYSTEM_TYPE,
      DictionariesActionsEnum.DICTIONARIES_KNO_SUPERVISION_GET_SUCCESS,
      KnmActionsEnum.KNM_SET_ERKNM_KNM_KIND_VERSION_ID_FORM_VALUE,
    ],
    initDictionariesEventUuidSaga,
  );
  yield takeEvery(
    [
      KnmActionsEnum.KNM_SET_SYSTEM_TYPE,
      DictionariesActionsEnum.DICTIONARIES_KNO_SUPERVISION_GET_SUCCESS,
      KnmActionsEnum.KNM_SET_ERKNM_KNM_KIND_VERSION_ID_FORM_VALUE,
    ],
    initDictionariesEventHasUnplannedActivitySaga,
  );
  yield takeEvery(
    [KnmActionsEnum.KNM_SET_SYSTEM_TYPE, DictionariesActionsEnum.DICTIONARIES_KNO_SUPERVISION_GET_SUCCESS],
    initDictionariesPositions,
  );
  yield takeEvery(
    [
      KnmActionsEnum.KNM_SET_SYSTEM_TYPE,
      KnmActionsEnum.KNM_SET_PM_SUPERVISION_TYPE,
      DictionariesActionsEnum.DICTIONARIES_KNO_SUPERVISION_GET_SUCCESS,
    ],
    initDictionariesPermitDocs,
  );
  yield takeEvery(
    [KnmActionsEnum.KNM_SET_SYSTEM_TYPE, DictionariesActionsEnum.DICTIONARIES_KNO_SUPERVISION_GET_SUCCESS],
    initDictionariesParticipantPositions,
  );
  yield takeEvery(
    [
      KnmActionsEnum.KNM_SET_SYSTEM_TYPE,
      DictionariesActionsEnum.DICTIONARIES_KNO_SUPERVISION_GET_SUCCESS,
      KnmActionsEnum.KNM_SET_ERKNM_REASONS_FORM_VALUE,
    ],
    initDictionariesSubjectTypesSaga,
  );
  yield takeEvery(
    [
      KnmActionsEnum.KNM_SET_SYSTEM_TYPE,
      DictionariesActionsEnum.DICTIONARIES_KNO_SUPERVISION_GET_SUCCESS,
      KnmActionsEnum.KNM_SET_ERKNM_REASONS_FORM_VALUE,
    ],
    initDictionariesSubjectKindsSaga,
  );
  yield takeEvery(
    [
      KnmActionsEnum.KNM_SET_SYSTEM_TYPE,
      DictionariesActionsEnum.DICTIONARIES_KNO_SUPERVISION_GET_SUCCESS,
      KnmActionsEnum.KNM_SET_ERKNM_REASONS_FORM_VALUE,
    ],
    initDictionariesSubjectSubKindsSaga,
  );
  yield takeEvery(
    [KnmActionsEnum.KNM_SET_SYSTEM_TYPE, DictionariesActionsEnum.DICTIONARIES_KNO_SUPERVISION_GET_SUCCESS],
    initDictionariesRiskIndicators,
  );
  yield takeEvery(
    [
      KnmActionsEnum.KNM_SET_SYSTEM_TYPE,
      DictionariesActionsEnum.DICTIONARIES_EVENT_UUID_GET_SUCCESS,
      KnmActionsEnum.KNM_SET_ERKNM_REASONS_FORM_VALUE,
      KnmActionsEnum.KNM_SET_TYPE_FORM_VALUE,
    ],
    initDictionariesRiskCategories,
  );
  yield takeEvery(
    [
      KnmActionsEnum.KNM_SET_SYSTEM_TYPE,
      DictionariesActionsEnum.DICTIONARIES_EVENT_UUID_GET_SUCCESS,
      KnmActionsEnum.KNM_SET_ERKNM_REASONS_FORM_VALUE,
      KnmActionsEnum.KNM_SET_TYPE_FORM_VALUE,
    ],
    initDictionariesDangerClassesSaga,
  );
  yield takeEvery(
    [
      KnmActionsEnum.KNM_SET_SYSTEM_TYPE,
      DictionariesActionsEnum.DICTIONARIES_EVENT_UUID_GET_SUCCESS,
      KnmActionsEnum.KNM_SET_ERKNM_REASONS_FORM_VALUE,
    ],
    initDictionaryEventTypesSaga,
  );
  yield takeEvery([KnmActionsEnum.KNM_SET_PM_IS_UNABLE_TO_REFUSE_FORM_VALUE], initDictionaryPmProfEventTypesSaga);
  yield takeEvery(
    [KnmActionsEnum.KNM_SET_SYSTEM_TYPE, DictionariesActionsEnum.DICTIONARIES_KNO_SUPERVISION_GET_SUCCESS],
    initDictionariesKnmTypes,
  );
  yield takeEvery(KnmActionsEnum.KNM_SET_SYSTEM_TYPE, initDictionariesConditionTypes);
}

const erpCommonCatalogsNames: Array<CommonCatalogsNamesEnum> = [
  CommonCatalogsNamesEnum.CHECKLIST_ANSWER_TYPES,
  CommonCatalogsNamesEnum.KNM_ADDRESS_TYPES,
  CommonCatalogsNamesEnum.KNM_DOCUMENT_TYPES,
  CommonCatalogsNamesEnum.KNM_INSPECTOR_TYPES,
  CommonCatalogsNamesEnum.KNM_RESULT_INFO_TYPES,
  CommonCatalogsNamesEnum.DISTRICTS,
];

const erknmCommonCatalogsNames: Array<CommonCatalogsNamesEnum> = [
  CommonCatalogsNamesEnum.CHECKLIST_ANSWER_TYPES,
  CommonCatalogsNamesEnum.KNM_DOCUMENT_TYPES,
  CommonCatalogsNamesEnum.ERKNM_KNM_DOCUMENT_TYPES,
  CommonCatalogsNamesEnum.DISTRICTS,
  CommonCatalogsNamesEnum.KNM_PLAN_REASON_CHANGE_TYPES,
  CommonCatalogsNamesEnum.COUNTRIES,
  CommonCatalogsNamesEnum.TERMINATION_REASONS,
];

function* initCommonCatalogsSaga() {
  const state: IRootState = yield select();
  const knmSystemType = getKnmSystemType(state);

  if (knmSystemType === KnmSystemTypesEnum.ERP) {
    yield all([...erpCommonCatalogsNames.map(catalogName => put(catalogGet(catalogName)))]);
  } else {
    yield all([
      ...erknmCommonCatalogsNames.map(catalogName => put(catalogGet(catalogName))),
      put(dictionariesKnoOrganizationsItemGet()),
    ]);
    yield put(dictionariesTargetEntityFounderItemGet());
  }
}

function* initAccountOrganizationsWithDistrictSaga() {
  const state: IRootState = yield select();
  const knmSystemType = getKnmSystemType(state);

  if (knmSystemType) {
    yield put(accountOrganizationsWithDistrictGet());
  }
}

function* initAccountKnoOrganizationFunctionsSaga() {
  const state: IRootState = yield select();
  const knmSystemType = getKnmSystemType(state);
  const formKnoOrganizationId = getKnmKnoOrganizationIdFormValue(state);

  if (knmSystemType === KnmSystemTypesEnum.ERP && formKnoOrganizationId) {
    yield put(
      accountKnoOrganizationFunctionsGet({
        knoOrganizationId: formKnoOrganizationId,
        isCaching: true,
      }),
    );
  }
}

function* initDictionariesKnoSupervisionUuidSaga() {
  const state: IRootState = yield select();
  const knmSystemType = getKnmSystemType(state);
  const knoOrganizationDictVersionId = getKnmErknmKnoOrganizationDictVersionIdFormValue(state);
  const supervisionTypeDictVersionId = getKnmErknmSupervisionTypeDictVersionIdFormValue(state);

  if (
    (knmSystemType === KnmSystemTypesEnum.ERKNM || knmSystemType === KnmSystemTypesEnum.PM) &&
    knoOrganizationDictVersionId &&
    supervisionTypeDictVersionId
  ) {
    yield put(dictionariesKnoSupervisionGet(knoOrganizationDictVersionId, supervisionTypeDictVersionId));
  }
}

function* initDictionariesEventUuidSaga() {
  const state: IRootState = yield select();
  const knmSystemType = getKnmSystemType(state);
  const knoOrganizationDictVersionId = getKnmErknmKnoOrganizationDictVersionIdFormValue(state);
  const supervisionTypeDictVersionId = getKnmErknmSupervisionTypeDictVersionIdFormValue(state);
  const knmKindDictVersionId = getKnmErknmKnmKindDictVersionIdFormValue(state);

  if (
    (knmSystemType === KnmSystemTypesEnum.ERKNM || knmSystemType === KnmSystemTypesEnum.PM) &&
    knoOrganizationDictVersionId &&
    supervisionTypeDictVersionId &&
    knmKindDictVersionId
  ) {
    yield put(
      dictionariesEventUuidGet(knoOrganizationDictVersionId, supervisionTypeDictVersionId, knmKindDictVersionId),
    );
  }
}

function* initDictionariesEventHasUnplannedActivitySaga() {
  const state: IRootState = yield select();
  const knmSystemType = getKnmSystemType(state);
  const knoOrganizationDictVersionId = getKnmErknmKnoOrganizationDictVersionIdFormValue(state);
  const supervisionTypeDictVersionId = getKnmErknmSupervisionTypeDictVersionIdFormValue(state);
  const knmKindDictVersionId = getKnmErknmKnmKindDictVersionIdFormValue(state);

  if (
    (knmSystemType === KnmSystemTypesEnum.ERKNM || knmSystemType === KnmSystemTypesEnum.PM) &&
    knoOrganizationDictVersionId &&
    supervisionTypeDictVersionId &&
    knmKindDictVersionId
  ) {
    yield put(
      dictionariesEventHasUnplannedActivityGet(
        knoOrganizationDictVersionId,
        supervisionTypeDictVersionId,
        knmKindDictVersionId,
      ),
    );
  }
}

function* initDictionariesPositions() {
  const state: IRootState = yield select();
  const knmSystemType = getKnmSystemType(state);
  const knoSupervisionUuid = getKnmKnoSupervisionUuid(state);

  if ((knmSystemType === KnmSystemTypesEnum.ERKNM || knmSystemType === KnmSystemTypesEnum.PM) && knoSupervisionUuid) {
    yield put(dictionariesPositionsItemGet(knoSupervisionUuid));
  }
}

/**
 * Инициализация получения списка разрешительных документов
 */
function* initDictionariesPermitDocs() {
  const state: IRootState = yield select();
  const knmSystemType = getKnmSystemType(state);
  let controlKindUuid = getControlKindUuid(state);
  const uuidKno = getKnmErknmKnoOrganizationDictVersionIdFormValue(state);

  const isErknm = knmSystemType === KnmSystemTypesEnum.ERKNM;
  const isPm = knmSystemType === KnmSystemTypesEnum.PM;

  if (isErknm || isPm) {
    if (!controlKindUuid) {
      const formRef = getKnmFormRef(state);

      controlKindUuid = formRef?.current.getFieldState(isPm ? 'supervisionTypePm' : 'kindControl')?.value?.value
        ?.dictVersionId;
    }

    if (controlKindUuid && uuidKno) {
      yield put(dictionariesPermitDocsItemGet(controlKindUuid, uuidKno));
    }
  }
}

function* initDictionariesParticipantPositions() {
  const state: IRootState = yield select();
  const knmSystemType = getKnmSystemType(state);
  const knoSupervisionUuid = getKnmKnoSupervisionUuid(state);

  if ((knmSystemType === KnmSystemTypesEnum.ERKNM || knmSystemType === KnmSystemTypesEnum.PM) && knoSupervisionUuid) {
    yield put(dictionariesParticipantPositionsItemGet(knoSupervisionUuid));
  }
}

function* initDictionariesAcceptedDocuments() {
  const state: IRootState = yield select();
  const knmSystemType = getKnmSystemType(state);
  const knoOrganizationDictVersionId = getKnmErknmKnoOrganizationDictVersionIdFormValue(state);
  const supervisionTypeDictVersionId = getKnmErknmSupervisionTypeDictVersionIdFormValue(state);

  if (
    (knmSystemType === KnmSystemTypesEnum.ERKNM || knmSystemType === KnmSystemTypesEnum.PM) &&
    knoOrganizationDictVersionId &&
    supervisionTypeDictVersionId
  ) {
    yield put(
      dictionariesAcceptedDocumentsItemGet({
        knoVersionId: knoOrganizationDictVersionId,
        supervisionVersionId: supervisionTypeDictVersionId,
      }),
    );
  }
}

function* initDictionariesRiskIndicators() {
  const state: IRootState = yield select();
  const knmSystemType = getKnmSystemType(state);
  const knoSupervisionUuid = getKnmKnoSupervisionUuid(state);

  if ((knmSystemType === KnmSystemTypesEnum.ERKNM || knmSystemType === KnmSystemTypesEnum.PM) && knoSupervisionUuid) {
    yield put(dictionariesRiskIndicatorsItemGet(knoSupervisionUuid));
  }
}

export function* initDictionariesTargetEntity() {
  const state: IRootState = yield select();
  const knmSystemType = getKnmSystemType(state);
  const knoOrganizationDictVersionId = getKnmErknmKnoOrganizationDictVersionIdFormValue(state);
  const supervisionTypeDictVersionId = getKnmErknmSupervisionTypeDictVersionIdFormValue(state);
  const reasonUuid =
    getKnmErknmReasonsFormValue(state)
      ?.map(x => x?.ervkUuid)
      ?.find(uuid => uuid) ||
    getKnmPmReasonsFormValue(state)
      ?.map(x => x.reason?.ervkUuid)
      ?.find(uuid => uuid) ||
    undefined;

  if (
    (knmSystemType === KnmSystemTypesEnum.ERKNM || knmSystemType === KnmSystemTypesEnum.PM) &&
    knoOrganizationDictVersionId &&
    supervisionTypeDictVersionId &&
    reasonUuid
  ) {
    yield put(
      dictionariesTargetEntityItemGet({
        knoVersionId: knoOrganizationDictVersionId,
        supervisionVersionId: supervisionTypeDictVersionId,
        conditionUuid: reasonUuid,
      }),
    );
  }
}

function* initDictionariesSubjectTypesSaga() {
  const state: IRootState = yield select();
  const knmSystemType = getKnmSystemType(state);
  const knoSupervisionUuid = getKnmKnoSupervisionUuid(state);
  const reasonUuid =
    getKnmErknmReasonsFormValue(state)
      ?.map(x => x?.ervkUuid)
      ?.find(uuid => uuid) ||
    getKnmPmReasonsFormValue(state)
      ?.map(x => x.reason?.ervkUuid)
      ?.find(uuid => uuid) ||
    undefined;

  if (
    (knmSystemType === KnmSystemTypesEnum.ERKNM || knmSystemType === KnmSystemTypesEnum.PM) &&
    knoSupervisionUuid &&
    reasonUuid
  ) {
    yield put(dictionariesSubjectTypesItemGet(knoSupervisionUuid, reasonUuid));
  }
}

function* initDictionariesSubjectKindsSaga() {
  const state: IRootState = yield select();
  const knmSystemType = getKnmSystemType(state);
  const knoSupervisionUuid = getKnmKnoSupervisionUuid(state);
  const reasonUuid =
    getKnmErknmReasonsFormValue(state)
      ?.map(x => x?.ervkUuid)
      ?.find(uuid => uuid) ||
    getKnmPmReasonsFormValue(state)
      ?.map(x => x.reason?.ervkUuid)
      ?.find(uuid => uuid) ||
    undefined;

  if (
    (knmSystemType === KnmSystemTypesEnum.ERKNM || knmSystemType === KnmSystemTypesEnum.PM) &&
    knoSupervisionUuid &&
    reasonUuid
  ) {
    yield put(dictionariesSubjectKindsItemGet(knoSupervisionUuid, reasonUuid));
  }
}

function* initDictionariesSubjectSubKindsSaga() {
  const state: IRootState = yield select();
  const knmSystemType = getKnmSystemType(state);
  const knoSupervisionUuid = getKnmKnoSupervisionUuid(state);
  const reasonUuid =
    getKnmErknmReasonsFormValue(state)
      ?.map(x => x?.ervkUuid)
      ?.find(uuid => uuid) ||
    getKnmPmReasonsFormValue(state)
      ?.map(x => x.reason?.ervkUuid)
      ?.find(uuid => uuid) ||
    undefined;

  if (
    (knmSystemType === KnmSystemTypesEnum.ERKNM || knmSystemType === KnmSystemTypesEnum.PM) &&
    knoSupervisionUuid &&
    reasonUuid
  ) {
    yield put(dictionariesSubjectSubKindsItemGet(knoSupervisionUuid, reasonUuid));
  }
}

function* initDictionariesRiskCategories() {
  const state: IRootState = yield select();
  const knmSystemType = getKnmSystemType(state);
  const knoSupervisionUuid = getKnmKnoSupervisionUuid(state);
  const knmKindUuid = getKnmErknmKnmKindDictVersionIdFormValue(state);
  const reasonUuid =
    getKnmErknmReasonsFormValue(state)
      ?.map(x => x?.ervkUuid)
      ?.find(uuid => uuid) ||
    getKnmPmReasonsFormValue(state)
      ?.map(x => x.reason?.ervkUuid)
      ?.find(uuid => uuid) ||
    undefined;
  const erknmTypeCode = getKnmTypeFormValue(state)?.value;

  const isErknm = knmSystemType === KnmSystemTypesEnum.ERKNM;
  const isPm = knmSystemType === KnmSystemTypesEnum.PM;

  if ((isErknm || isPm) && knoSupervisionUuid && (!isPm || reasonUuid) && (!isErknm || knmKindUuid)) {
    yield put(
      dictionariesRiskCategoriesItemGet(
        knoSupervisionUuid,
        reasonUuid,
        undefined,
        isErknm ? knmKindUuid : undefined,
        erknmTypeCode === KnmTypeCodesEnum.PP,
      ),
    );
  }
}

function* initDictionariesDangerClassesSaga() {
  const state: IRootState = yield select();
  const knmSystemType = getKnmSystemType(state);
  const knoSupervisionUuid = getKnmKnoSupervisionUuid(state);
  const reasonUuid =
    getKnmErknmReasonsFormValue(state)
      ?.map(x => x?.ervkUuid)
      ?.find(uuid => uuid) ||
    getKnmPmReasonsFormValue(state)
      ?.map(x => x.reason?.ervkUuid)
      ?.find(uuid => uuid) ||
    undefined;
  const erknmTypeCode = getKnmTypeFormValue(state)?.value;

  if (
    (knmSystemType === KnmSystemTypesEnum.ERKNM || knmSystemType === KnmSystemTypesEnum.PM) &&
    knoSupervisionUuid &&
    reasonUuid
  ) {
    yield put(
      dictionariesDangerClassesItemGet(
        knoSupervisionUuid,
        reasonUuid,
        undefined,
        erknmTypeCode === KnmTypeCodesEnum.PP,
      ),
    );
  }
}

function* initCatalogKnmReasonTypesSaga() {
  const state: IRootState = yield select();
  const knmTypeId = getKnmTypeIdFormValue(state);
  const knmSystemType = getKnmSystemType(state);

  if (typeof knmTypeId === 'number' && knmSystemType === KnmSystemTypesEnum.ERP) {
    yield put(catalogKnmReasonTypesGet(knmTypeId, true));
  }
}

function* initCatalogKnmRejectReasonTypesSaga() {
  const state: IRootState = yield select();
  const knmTypeId = getKnmTypeIdFormValue(state);

  if (typeof knmTypeId === 'number') {
    yield put(catalogKnmRejectReasonTypesGet(knmTypeId));
  }
}

function* initCatalogErknmKnmRejectReasonTypesSaga() {
  const state: IRootState = yield select();
  const knmSystemType = getKnmSystemType(state);
  const isPlanned = getKnmTypeFormValue(state)?.value === KnmTypeCodesEnum.PP;

  if (knmSystemType === KnmSystemTypesEnum.ERKNM && typeof isPlanned === 'boolean') {
    yield put(catalogErknmKnmRejectReasonTypesGet(isPlanned));
  }
}

function* initCatalogErknmKnmConditionsSaga() {
  const state: IRootState = yield select();
  const knmSystemType = getKnmSystemType(state);

  const knoOrganizationDictVersionId = getKnmErknmKnoOrganizationDictVersionIdFormValue(state);
  const supervisionTypeDictVersionId = getKnmErknmSupervisionTypeDictVersionIdFormValue(state);
  const erknmTypeCode =
    knmSystemType === KnmSystemTypesEnum.ERKNM
      ? getKnmTypeFormValue(state)?.value
      : state.knm?.formValues?.pmType?.code;

  const erknmKind = getKnmErknmKnmKindDictVersionIdFormValue(state);

  if (
    knmSystemType === KnmSystemTypesEnum.ERKNM &&
    knoOrganizationDictVersionId &&
    supervisionTypeDictVersionId &&
    erknmTypeCode
  ) {
    yield put(
      catalogErknmKnmConditionsGet(
        knoOrganizationDictVersionId,
        supervisionTypeDictVersionId,
        erknmTypeCode,
        erknmKind,
      ),
    );
  }
}

function* initCatalogPmReasonTypesSaga() {
  const state: IRootState = yield select();
  const knmSystemType = getKnmSystemType(state);

  const knoOrganizationDictVersionId = getKnmErknmKnoOrganizationDictVersionIdFormValue(state);
  const supervisionTypeDictVersionId = getKnmErknmSupervisionTypeDictVersionIdFormValue(state);
  const profKindId = state.knm?.formValues?.erknmKnmKindVersionId;

  if (knmSystemType === KnmSystemTypesEnum.PM && knoOrganizationDictVersionId && supervisionTypeDictVersionId) {
    yield put(catalogPmConditionsGet(knoOrganizationDictVersionId, supervisionTypeDictVersionId, profKindId));
  }
}

function* initCatalogKnmSupervisionTypesByKnmTypeAndSubjectTypeSaga() {
  const state: IRootState = yield select();
  const knmTypeId = getKnmTypeIdFormValue(state);
  const subjectTypeId = getKnmSubjectTypeIdFormValue(state);

  if (typeof knmTypeId === 'number' && typeof subjectTypeId === 'number') {
    yield put(
      catalogKnmSupervisionTypesByKnmTypeAndSubjectTypeGet({
        knmTypeId,
        subjectTypeId,
      }),
    );
  }
}

function* initDictionaryKnmSupervisionTypesSaga() {
  const state: IRootState = yield select();
  const knoOrganizationDictVersionId = getKnmErknmKnoOrganizationDictVersionIdFormValue(state);

  if (knoOrganizationDictVersionId) {
    const isPlanned: boolean = getKnmIsTypeErknmPlanned(state) || !!getKnmDataPlanId(state);

    yield put(dictionariesSupervisionTypesItemGet([knoOrganizationDictVersionId], isPlanned, [FEDERAL_LOW_248_GUID]));
  }
}

function* initDictionaryKnmKindsSaga() {
  const state: IRootState = yield select();
  const knmSystemType = getKnmSystemType(state);
  const knoOrganizationDictVersionId = getKnmErknmKnoOrganizationDictVersionIdFormValue(state);
  const supervisionTypeDictVersionId = getKnmErknmSupervisionTypeDictVersionIdFormValue(state);
  const reasonUuid =
    getKnmErknmReasonsFormValue(state)
      ?.map(x => x.ervkUuid)
      ?.find(uuid => uuid) ||
    getKnmPmReasonsFormValue(state)
      ?.map(x => x.reason?.ervkUuid)
      ?.find(uuid => uuid) ||
    undefined;

  if (
    (knmSystemType === KnmSystemTypesEnum.ERKNM || knmSystemType === KnmSystemTypesEnum.PM) &&
    knoOrganizationDictVersionId &&
    supervisionTypeDictVersionId &&
    reasonUuid
  ) {
    yield put(
      dictionariesKnmKindsItemGet({
        knoVersionId: knoOrganizationDictVersionId,
        supervisionVersionId: supervisionTypeDictVersionId,
        conditionUuid: reasonUuid,
      }),
    );
  }
}

function* initDictionaryProfKindsSaga() {
  const state: IRootState = yield select();
  const isErknm = getCoreIsErknm(state);
  const knmSystemType = getKnmSystemType(state);
  const knoOrganizationDictVersionId = getKnmErknmKnoOrganizationDictVersionIdFormValue(state);
  const supervisionTypeDictVersionId = getKnmErknmSupervisionTypeDictVersionIdFormValue(state);
  const reasonUuid = isErknm
    ? getKnmErknmReasonsFormValue(state)
        ?.map(x => x?.ervkUuid)
        ?.find(uuid => uuid) ||
      getKnmPmReasonsFormValue(state)
        ?.map(x => x.reason?.ervkUuid)
        ?.find(uuid => uuid) ||
      undefined
    : undefined;

  if (
    knmSystemType === KnmSystemTypesEnum.PM &&
    knoOrganizationDictVersionId &&
    supervisionTypeDictVersionId &&
    (isErknm ? reasonUuid : true)
  ) {
    yield put(
      dictionariesProfKindsItemGet(
        {
          knoVersionId: knoOrganizationDictVersionId,
          supervisionVersionId: supervisionTypeDictVersionId,
        },
        reasonUuid,
      ),
    );
  }
}

function* initDictionaryEventTypesSaga() {
  const state: IRootState = yield select();
  const knmSystemType = getKnmSystemType(state);
  const reasonUuid =
    getKnmErknmReasonsFormValue(state)
      ?.map(x => x?.ervkUuid)
      ?.find(uuid => uuid) ||
    getKnmPmReasonsFormValue(state)
      ?.map(x => x.reason?.ervkUuid)
      ?.find(uuid => uuid) ||
    undefined;

  const isPm = knmSystemType === KnmSystemTypesEnum.PM;
  const isErknm = knmSystemType === KnmSystemTypesEnum.ERKNM;

  const uniqueUuid = isErknm ? getKnmEventUuid(state)?.find(x => x) : getKnmKnoSupervisionUuid(state);

  if ((isErknm || isPm) && uniqueUuid && reasonUuid) {
    yield put(dictionariesEventTypesItemGet(isPm, uniqueUuid, reasonUuid));
  }
}

function* initDictionaryPmProfEventTypesSaga() {
  const state: IRootState = yield select();

  const isUnableToRefuse = getKnmPmIsUnableToRefuseFormValue(state);

  yield put(dictionariesPmProfEventTypesItemGet(isUnableToRefuse));
}

function* initDictionaryChecklistsSaga() {
  const state: IRootState = yield select();
  const knoOrganizationDictVersionId = getKnmErknmKnoOrganizationDictVersionIdFormValue(state);
  const supervisionTypeDictVersionId = getKnmErknmSupervisionTypeDictVersionIdFormValue(state);

  if (knoOrganizationDictVersionId && supervisionTypeDictVersionId) {
    yield put(
      dictionariesChecklistsItemGet({
        uuidKno: knoOrganizationDictVersionId,
        uuidSupervision: supervisionTypeDictVersionId,
      }),
    );
  }
}

function* initErvkChecklistsSaga() {
  const state: IRootState = yield select();
  const supervisionTypeDictVersionId = getKnmErknmSupervisionTypeDictVersionIdFormValue(state);
  const knmKindDictVersionId = getKnmErknmKnmKindDictVersionIdFormValue(state);
  const initObjects = getKnmDataErknmObjects(state);

  const subjectKindIds: string[] = [];

  initObjects?.forEach(item => {
    if (item.objectKind && subjectKindIds?.indexOf(item.objectKind.dictVersionId) === -1) {
      subjectKindIds?.push(item.objectKind.dictVersionId);
    }
  });

  if (knmKindDictVersionId && supervisionTypeDictVersionId) {
    yield put(
      dictionariesErvkCheckListGet({
        controlKindId: supervisionTypeDictVersionId,
        knmKindId: knmKindDictVersionId,
        subjectKindIds,
      }),
    );
  }
}

function* initDictionaryRequirementsSaga() {
  const state: IRootState = yield select();
  const knoOrganizationDictVersionId = getKnmErknmKnoOrganizationDictVersionIdFormValue(state);
  const supervisionTypeDictVersionId = getKnmErknmSupervisionTypeDictVersionIdFormValue(state);

  if (knoOrganizationDictVersionId && supervisionTypeDictVersionId) {
    yield put(
      dictionariesRequirementsItemGet({
        uuidKno: knoOrganizationDictVersionId,
        uuidSupervision: supervisionTypeDictVersionId,
      }),
    );
  }
}

function* initRegistryExportOkvedSaga(action: ActionType<typeof knmSetLegalEntityData>) {
  const { data } = action.payload;

  if (data) {
    yield put(registryExportOkvedGet(data));
  }
}

function* initDictionariesKnmTypes() {
  const state: IRootState = yield select();
  const knmSystemType = getKnmSystemType(state);
  const knoSupervisionUuid = getKnmKnoSupervisionUuid(state);

  if (knmSystemType === KnmSystemTypesEnum.ERKNM && knoSupervisionUuid) {
    yield put(dictionariesKnmTypesItemGet(knoSupervisionUuid));
  }
}

function* initDictionariesKnmTypesByKnoAndSupervisionSaga() {
  const state: IRootState = yield select();
  const knoOrganizationDictVersionId = getKnmErknmKnoOrganizationDictVersionIdFormValue(state);
  const supervisionTypeDictVersionId = getKnmErknmSupervisionTypeDictVersionIdFormValue(state);

  if (knoOrganizationDictVersionId && supervisionTypeDictVersionId) {
    yield put(
      catalogKnmTypes248Get({
        knoVersionId: knoOrganizationDictVersionId,
        supervisionVersionId: supervisionTypeDictVersionId,
      }),
    );
  }
}

function* initDictionariesConditionTypes() {
  const state: IRootState = yield select();
  const knmSystemType = getKnmSystemType(state);

  if (knmSystemType !== KnmSystemTypesEnum.ERP) {
    yield put(dictionariesConditionTypesItemGet(knmSystemType));
  }
}
